module.exports = __webpack_public_path__ + "static/requiredFormatNo-888bb26fbb89893460ac7838900f2c60.png";